import React from 'react';
// The App component's contents are currently a placeholder — please update this file first for a new design / component!
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import VitalStatisticsReport from './pages/VitalStatisticsReport';
import TrafficOffensesReport from './pages/TrafficOffensesReport';
import PropertyTaxReport from './pages/PropertyTaxReport';
import { HomeIcon, ActivityIcon, CarIcon, HomeIcon as BuildingIcon } from 'lucide-react';
const Navigation = () => {
  const location = useLocation();
  const navItems = [{
    path: '/',
    label: 'Dashboard',
    icon: <HomeIcon size={20} data-id="element-0" />
  }, {
    path: '/vital-statistics',
    label: 'Vital Statistics',
    icon: <ActivityIcon size={20} data-id="element-1" />
  }, {
    path: '/traffic-offenses',
    label: 'Traffic Offenses',
    icon: <CarIcon size={20} data-id="element-2" />
  }, {
    path: '/property-tax',
    label: 'Property Tax',
    icon: <BuildingIcon size={20} data-id="element-3" />
  }];
  return <div className="bg-gray-800 text-white h-screen w-64 fixed left-0 top-0 p-4" data-id="element-4">
      <div className="mb-8" data-id="element-5">
        <h1 className="text-xl font-bold" data-id="element-6">Government Reports</h1>
        <p className="text-gray-400 text-sm" data-id="element-7">Public Policy Dashboard</p>
      </div>
      <nav data-id="element-8">
        <ul className="space-y-2" data-id="element-9">
          {navItems.map(item => <li key={item.path} data-id="element-10">
              <Link to={item.path} className={`flex items-center gap-3 p-3 rounded-md hover:bg-gray-700 transition-colors ${location.pathname === item.path ? 'bg-gray-700 text-blue-400' : ''}`} data-id="element-11">
                {item.icon}
                <span data-id="element-12">{item.label}</span>
              </Link>
            </li>)}
        </ul>
      </nav>
    </div>;
};
const Dashboard = () => {
  return <div className="p-6" data-id="element-13">
      <h1 className="text-2xl font-bold mb-6" data-id="element-14">Vital Statistics Dashboard</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-15">
        <Link to="/vital-statistics" className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition-shadow" data-id="element-16">
          <div className="flex items-start gap-3 mb-3" data-id="element-17">
            <div className="bg-blue-100 p-2 rounded-md" data-id="element-18">
              <ActivityIcon className="text-blue-600" size={22} data-id="element-19" />
            </div>
            <div data-id="element-20">
              <h2 className="text-lg font-semibold text-gray-800" data-id="element-21">
                Vital Statistics Report
              </h2>
            </div>
          </div>
          <p className="text-gray-600 mb-4" data-id="element-22">
            Analyze demographic trends for national planning including births,
            deaths, and marriages data.
          </p>
          <div className="flex flex-wrap gap-2 mb-4" data-id="element-23">
            <span className="bg-blue-50 text-blue-700 text-xs px-3 py-1 rounded-full" data-id="element-24">
              Demographics
            </span>
            <span className="bg-green-50 text-green-700 text-xs px-3 py-1 rounded-full" data-id="element-25">
              Civil Registration
            </span>
            <span className="bg-purple-50 text-purple-700 text-xs px-3 py-1 rounded-full" data-id="element-26">
              Population
            </span>
          </div>
          <div className="mb-4" data-id="element-27">
            <p className="text-sm text-gray-500" data-id="element-28">
              <span className="font-medium" data-id="element-29">Target Audience:</span> National
              Statistics Office, Ministry of Health, Policy Planners
            </p>
          </div>
          <button className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-md text-sm font-medium transition-colors" data-id="element-30">
            View Report
          </button>
        </Link>
        <Link to="/traffic-offenses" className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition-shadow" data-id="element-31">
          <div className="flex items-start gap-3 mb-3" data-id="element-32">
            <div className="bg-red-100 p-2 rounded-md" data-id="element-33">
              <CarIcon className="text-red-600" size={22} data-id="element-34" />
            </div>
            <div data-id="element-35">
              <h2 className="text-lg font-semibold text-gray-800" data-id="element-36">
                Traffic Offenses & Public Safety Report
              </h2>
            </div>
          </div>
          <p className="text-gray-600 mb-4" data-id="element-37">
            Analyze traffic violation patterns to improve road safety and
            enforcement strategies.
          </p>
          <div className="flex flex-wrap gap-2 mb-4" data-id="element-38">
            <span className="bg-red-50 text-red-700 text-xs px-3 py-1 rounded-full" data-id="element-39">
              Public Safety
            </span>
            <span className="bg-yellow-50 text-yellow-700 text-xs px-3 py-1 rounded-full" data-id="element-40">
              Traffic
            </span>
            <span className="bg-green-50 text-green-700 text-xs px-3 py-1 rounded-full" data-id="element-41">
              Enforcement
            </span>
          </div>
          <div className="mb-4" data-id="element-42">
            <p className="text-sm text-gray-500" data-id="element-43">
              <span className="font-medium" data-id="element-44">Target Audience:</span> Traffic
              Police Command, Ministry of Transport, Public Safety Analysts
            </p>
          </div>
          <button className="bg-red-600 hover:bg-red-700 text-white px-5 py-2 rounded-md text-sm font-medium transition-colors" data-id="element-45">
            View Report
          </button>
        </Link>
        <Link to="/property-tax" className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition-shadow" data-id="element-46">
          <div className="flex items-start gap-3 mb-3" data-id="element-47">
            <div className="bg-green-100 p-2 rounded-md" data-id="element-48">
              <BuildingIcon className="text-green-600" size={22} data-id="element-49" />
            </div>
            <div data-id="element-50">
              <h2 className="text-lg font-semibold text-gray-800" data-id="element-51">
                Property Tax Report
              </h2>
            </div>
          </div>
          <p className="text-gray-600 mb-4" data-id="element-52">
            Analyze property tax collection trends and identify revenue
            opportunities for municipal planning.
          </p>
          <div className="flex flex-wrap gap-2 mb-4" data-id="element-53">
            <span className="bg-green-50 text-green-700 text-xs px-3 py-1 rounded-full" data-id="element-54">
              Revenue
            </span>
            <span className="bg-blue-50 text-blue-700 text-xs px-3 py-1 rounded-full" data-id="element-55">
              Municipal
            </span>
            <span className="bg-purple-50 text-purple-700 text-xs px-3 py-1 rounded-full" data-id="element-56">
              Property
            </span>
          </div>
          <div className="mb-4" data-id="element-57">
            <p className="text-sm text-gray-500" data-id="element-58">
              <span className="font-medium" data-id="element-59">Target Audience:</span> Treasury
              Department, Municipal Authorities, Tax Assessors
            </p>
          </div>
          <button className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-md text-sm font-medium transition-colors" data-id="element-60">
            View Report
          </button>
        </Link>
      </div>
    </div>;
};
export function App() {
  return <Router data-id="element-61">
      <div className="flex bg-gray-100 min-h-screen" data-id="element-62">
        <Navigation data-id="element-63" />
        <div className="ml-64 w-full" data-id="element-64">
          <Routes data-id="element-65">
            <Route path="/" element={<Dashboard data-id="element-67" />} data-id="element-66" />
            <Route path="/vital-statistics" element={<VitalStatisticsReport data-id="element-69" />} data-id="element-68" />
            <Route path="/traffic-offenses" element={<TrafficOffensesReport data-id="element-71" />} data-id="element-70" />
            <Route path="/property-tax" element={<PropertyTaxReport data-id="element-73" />} data-id="element-72" />
          </Routes>
        </div>
      </div>
    </Router>;
}